import {AbstractEditControlComponent} from "../../entity/edit/edit-controls/abstract-edit-control.component";

/**
 * Abstract edit control class that inverts a boolean value for display
 */
export class AbstractInvertedBooleanEditControlComponent extends AbstractEditControlComponent {
    override get value(): any {
        return !super.value;
    }

    override set value(value: any) {
        super.value = !value;
    }
}
